module.exports = __webpack_public_path__ + "img/number_s_spritesheet_yellow.3409e90e.png";